import React, { useEffect, useRef, useState } from "react";
import PanneauLateral from "../../common/PanneauLateral/PanneauLateral";
import { EmptyState } from "../../common/DataList";
import { libelleVersion, texteEntree } from "./reglesSousOrientation";
import { voirHistorique } from "./reglesSousOrientationApi";

// ============================================================
// Historique d'une version (CE-1419), lu dans le journal de traçabilité :
// la modification la plus récente d'abord, par pages de 20. Chaque règle s'y
// lit en une phrase, avant et après pour une modification.
// ============================================================

const PanneauHistorique = ({ version, onFermer }) => {
  const [entrees, setEntrees] = useState([]);
  const [page, setPage] = useState(1);
  const [suivante, setSuivante] = useState(false);
  const [chargement, setChargement] = useState(true);
  const [erreur, setErreur] = useState(null);
  // Un panneau fermé avant la réponse n'écrit plus rien.
  const monte = useRef(true);
  useEffect(() => () => {
    monte.current = false;
  }, []);

  const charger = (numero) => {
    setChargement(true);
    setErreur(null);
    voirHistorique(version.id, numero).then(
      (lu) => {
        if (!monte.current) return;
        setEntrees((actuelles) => (numero === 1 ? lu.data : [...actuelles, ...lu.data]));
        setPage(numero);
        setSuivante(lu.hasNext);
        setChargement(false);
      },
      (e) => {
        if (!monte.current) return;
        setErreur(e.message || "L'historique n'a pas pu être chargé.");
        setChargement(false);
      }
    );
  };

  useEffect(() => {
    charger(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [version.id]);

  return (
    <PanneauLateral ouvert onFermer={onFermer} titre="Historique des modifications" surtitre="Règles de sous-orientation">
      <h2 className="historique-regles__titre">Historique des modifications</h2>
      <p className="historique-regles__aide">
        {libelleVersion(version)}. Une modification vaut pour les orientations suivantes ; un allocataire déjà sous-orienté garde la règle qui lui a été
        appliquée.
      </p>
      <section className="historique-regles__carte" aria-busy={chargement ? "true" : undefined}>
        {erreur && <EmptyState icon="fa-exclamation-circle" title="L'historique n'a pas pu être chargé" hint={erreur} erreur action={{ label: "Réessayer", onClick: () => charger(page) }} />}
        {!erreur && !chargement && entrees.length === 0 && <EmptyState icon="fa-history" title="Aucune modification" hint="Cette version n'a pas encore été modifiée." />}
        {entrees.length > 0 && (
          <ol className="historique-regles">
            {entrees.map((entree) => {
              const texte = texteEntree(entree);
              return (
                <li key={entree.id}>
                  <span className="historique-regles__quand">{texte.quand}</span>
                  <div>
                    {texte.lignes.map((ligne) => (
                      <p key={ligne} className="historique-regles__ligne">
                        {ligne}
                      </p>
                    ))}
                    <p className="historique-regles__qui">{texte.qui}</p>
                  </div>
                </li>
              );
            })}
          </ol>
        )}
        {chargement && <p className="regles-chargement">Chargement de l'historique…</p>}
      </section>
      {suivante && !chargement && (
        <button type="button" className="btn btn-ghost btn-sm historique-regles__plus" onClick={() => charger(page + 1)}>
          Voir les modifications plus anciennes
        </button>
      )}
    </PanneauLateral>
  );
};

export default PanneauHistorique;
